import { App } from "@capacitor/app"

type ForegroundEvent = () => void

const foregroundedEvents: ForegroundEvent[] = []

export function addForegroundedEvent(evt: ForegroundEvent) {
    foregroundedEvents.push(evt)
}

App.addListener("appStateChange", (state) => {
    if (state.isActive) {
        console.log("App is active state")
        for (const event of foregroundedEvents) event()
    }
})

App.addListener("resume", () => {
    console.log("App is resumed")
    for (const event of foregroundedEvents) event()
})
